import { render, staticRenderFns } from "./AboutSkinxs.vue?vue&type=template&id=18f439ea&scoped=true"
import script from "./AboutSkinxs.vue?vue&type=script&lang=js"
export * from "./AboutSkinxs.vue?vue&type=script&lang=js"
import style0 from "./AboutSkinxs.vue?vue&type=style&index=0&id=18f439ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f439ea",
  null
  
)

export default component.exports